import React from "react";
import { Button } from "react-bootstrap";
import { getWarmTransferParticipant } from "../assets/library/helper";
import warmtransfercomplete from "../../../Dialer/CallListContainer/assets/images/warmtransfercomplete.svg";
const { REACT_APP_STATIC_ASSETS_BASE_URL } = process.env;
class CompleteTransferButton extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { checkIfAllCallsYetToAnswer, callElement, completeTransferCall } =
      this.props;
    return (
      <Button
        className="removecolorbut "
        disabled={
          checkIfAllCallsYetToAnswer(callElement) > 0 ||
          window.shouldDisableTransferActionBtn
        }
        onClick={() => {
          window.shouldDisableTransferActionBtn = true;
          completeTransferCall(
            callElement,
            getWarmTransferParticipant(callElement)
          );
        }}
      >
        <img
          alt=""
          src={`${REACT_APP_STATIC_ASSETS_BASE_URL}${warmtransfercomplete}`}
        />
        <h4>Complete Transfer</h4>
      </Button>
    );
  }
}

export default CompleteTransferButton;
